/* eslint-disable */
import PropTypes from 'prop-types';
import ThemeStatePropTypes from '../../State/Store/Theme/Theme.props';

const OrderActionsPropTypes = {
  /**
   * The JSS classes to use
   */
  classes: ThemeStatePropTypes.classes.isRequired,

  /**
   * The order details
   */
  details: PropTypes.any,

  /**
   * The JSS theme to use
   */
  theme: ThemeStatePropTypes.theme.isRequired,

  /**
   * The width of the screen
   */
  width: PropTypes.string.isRequired,
};

export default OrderActionsPropTypes;
